export const formatPhoneForZoom = (phone) => {
  const cleanPhone = phone.replace(/[^\d+]/g, "");
  if (cleanPhone.startsWith("+")) return cleanPhone;
  if (cleanPhone.length === 10) return "+1" + cleanPhone;
  if (cleanPhone.length === 11 && cleanPhone.startsWith("1"))
    return "+" + cleanPhone;
  return cleanPhone;
};
